import { useState, useEffect } from 'react';
import http from 'hub-http/clients/apiClient';
import usePrevious from 'react-utils/hooks/usePrevious';
import { RequestStatuses } from 'content-management-data-lib';
export default function useGetAPI(key, apiUrl, query) {
  const [requestStatus, setRequestStatus] = useState(RequestStatuses.UNINITIALIZED);
  const [responseData, setResponseData] = useState({});
  const prevKey = usePrevious(key);
  useEffect(() => {
    if (prevKey && key && prevKey !== key) {
      // using `key` to reset `requestStatus` to refetch data for new content
      setRequestStatus(RequestStatuses.UNINITIALIZED);
    }
  }, [key, prevKey]);
  useEffect(() => {
    if (requestStatus === RequestStatuses.UNINITIALIZED) {
      setRequestStatus(RequestStatuses.PENDING);
      http.get(apiUrl, {
        query
      }).then(data => {
        setResponseData(data);
        setRequestStatus(RequestStatuses.SUCCEEDED);
      }).catch(() => setRequestStatus(RequestStatuses.FAILED));
    }
  }, [apiUrl, query, requestStatus]);
  return {
    requestStatus,
    responseData
  };
}